import { Box } from '@monorepo/nova-ui';
import { styled } from '@mui/material/styles';

export const StyledMain = styled(Box)(({ theme }) => ({
  /* Responsive padding on different screen sizes */
  '& .responsive-padding-x': {
    paddingInline: `${theme.spacing(5)} !important`,
    [theme.breakpoints.up('sm')]: {
      paddingInline: `${theme.spacing(8)} !important`,
    },
    [theme.breakpoints.up('xl')]: {
      paddingInline: `${theme.spacing(20)} !important`,
    },
    [theme.breakpoints.up('gs')]: {
      paddingInline: `0 !important`,
    },
  },
  '& .main-content': {
    [theme.breakpoints.up('gs')]: {
      width: theme.spacing(650),
      marginInline: 'auto',
      paddingInline: theme.spacing(20),
    },
  },
}));
